export default {
  closed: false,
  canInteract: true,
  backgroundImage: '',
  distancingOrder: false,
  defaultDeliveryMethod: null,
  version: null,
  isQR: false,
  language: 'is',
};
